// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormChangeStatusPO } from '~/utils/interface/purchaseOrder';

export const schema = (t: TFunction): yup.ObjectSchema<IFormChangeStatusPO> => {
  return yup.object().shape({
    status: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesChangeStatus: IFormChangeStatusPO = {
  status: EMPTY_STRING,
};
